import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patsidebar',
  templateUrl: './patsidebar.component.html',
  styleUrls: ['./patsidebar.component.css']
})
export class PatsidebarComponent implements OnInit {

  constructor(private authservice:AuthService) { }

  ngOnInit(): void {
  }
  
}
